import { Inject, Injectable, LOCALE_ID } from "@angular/core"
import { ModelAnalytics } from "../common/organisation"
import { ORGANISATION_API, RepositoryService } from "../linq-utils/repository.service"
import { UserService } from "../user/user.service"
import { LineData } from "../charts/line-chart/line-chart.component"
import { formatDate } from "@angular/common"
import { analyticsByDay, NUMBER_DAYS } from "./analytics-days"

export interface AnalyticsData {
    analytics:ModelAnalytics[]
    orphanedNodes:number,
    orphanedEdges:number
}

const COMPONENT = "Analytics service"

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {

    constructor(private repoService:RepositoryService, @Inject(LOCALE_ID) public locale: string, private userService:UserService) {
    }

    async loadAnalyticsData(organisationKey:string, projectKey?:string, modelKey?:string):Promise<AnalyticsData> {
        const SERVICE = "Load analytics"
        const url = ORGANISATION_API(organisationKey, projectKey) + "/analytics?days=" + NUMBER_DAYS + (modelKey?"&modelKey="+encodeURIComponent(modelKey):"")
        return await this.repoService.callSingleAPI(this.repoService.getData<AnalyticsData>(url), COMPONENT, SERVICE, this.userService.getUser())
    }

    // the changes saved each day, and the organisation's node count, for the last few weeks
    loadAnalyticsDataForChart(analytics:ModelAnalytics[]):{changes:LineData, nodes:LineData} {
        const daily = analyticsByDay(analytics)
        const labels = daily.days.map(d => formatDate(d, "dd/MM/yy", this.locale))

        const lineData = new LineData()
        lineData.labels = labels
        lineData.addLine("Nodes added", daily.newNodes)
        lineData.addLine("Edges added", daily.newEdges)
        lineData.addLine("Nodes changed", daily.nodeChanges)
        lineData.addLine("Edges changed", daily.edgeChanges)
        lineData.addLine("Nodes deleted", daily.deletedNodes)
        lineData.addLine("Edges deleted", daily.deletedEdges)

        const nodesData = new LineData()
        nodesData.labels = labels
        nodesData.addLine("Total nodes", daily.nodes)

        return {changes:lineData, nodes:nodesData}
    }
}
